
    <div class="cover loader" *ngIf="(isLoading$ | async) || isLoading">
      <div class="centered">
        <div class="c-loader">
          <img src="assets/img/icons/icon-spinner-gray.svg" />
        </div>
      </div>
    </div>
  